import { supabase } from "@/integrations/supabase/client";
import type { Database } from "@/integrations/supabase/types";

export type ContentBlockRow = Database["public"]["Tables"]["content_blocks"]["Row"];
export type ContentBlockUpdate = Database["public"]["Tables"]["content_blocks"]["Update"];
export type ContentBlockInsert = Database["public"]["Tables"]["content_blocks"]["Insert"];

export interface StatItem {
  icon?: string;
  value: string;
  label: string;
}

export const CONTENT_KEYS = {
  HERO: "hero",
  INSTITUTIONAL: "institutional",
  SOCIAL_PROOF: "social_proof",
  NEWSLETTER: "newsletter",
} as const;

export async function listContentBlocks(): Promise<ContentBlockRow[]> {
  const { data, error } = await supabase
    .from("content_blocks")
    .select("*")
    .order("sort_order", { ascending: true });
  if (error) throw error;
  return data ?? [];
}

export async function getContentBlock(key: string): Promise<ContentBlockRow | null> {
  const { data, error } = await supabase
    .from("content_blocks")
    .select("*")
    .eq("key", key)
    .maybeSingle();
  if (error) throw error;
  return data;
}

export async function updateContentBlock(
  id: string,
  payload: ContentBlockUpdate,
): Promise<ContentBlockRow> {
  const { data, error } = await supabase
    .from("content_blocks")
    .update(payload)
    .eq("id", id)
    .select("*")
    .single();
  if (error) throw error;
  return data;
}

const BUCKET = "content-images";

export async function uploadContentImage(file: File, key: string): Promise<string> {
  const ext = file.name.split(".").pop()?.toLowerCase() || "jpg";
  const path = `${key}/${Date.now()}.${ext}`;
  const { error } = await supabase.storage.from(BUCKET).upload(path, file, {
    cacheControl: "3600",
    upsert: false,
  });
  if (error) throw error;
  const { data } = supabase.storage.from(BUCKET).getPublicUrl(path);
  return data.publicUrl;
}
